import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import StoreButtons from '../../components/StoreButtons';

const Home = () => {
  const features = [
    {
      id: 1,
      image: '/images/1.jpg',
      title: 'Multi-Language Support',
      description: 'Choose from multiple languages to make your ordering experience seamless and comfortable.'
    },
    {
      id: 2,
      image: '/images/2.jpg',
      title: 'Smart Location & Restaurant Selection',
      description: 'Get automatically localized and browse through nearby restaurants with our intuitive carousel interface.'
    },
    {
      id: 3,
      image: '/images/3.jpg',
      title: 'Easy Table Selection',
      description: 'Select your table with just a few taps and start ordering immediately.'
    },
    {
      id: 4,
      image: '/images/4.jpg',
      title: 'Browse & Order Menu Items',
      description: 'Explore the restaurant menu, customize your dishes, and add items to your order effortlessly.'
    },
    {
      id: 5,
      image: '/images/5.jpg',
      title: 'Manage Your Order',
      description: 'Extend your order, modify items, and request payment when you\'re ready - all in one place.'
    },
    {
      id: 6,
      image: '/images/6.jpg',
      title: 'Quick Payment',
      description: 'Review your order summary and complete payment securely through the app.'
    },
    {
      id: 7,
      image: '/images/7.jpg',
      title: 'User Profile',
      description: 'Manage personal data, view transaction history, payment methods, and access app settings.'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%), url(${process.env.PUBLIC_URL}/images/background.png)`
        }}
      >
        <div className="hero-content">
          <img src="/images/ow-client-logo.png" alt="OW Logo" className="hero-logo" />
          <h1 className="hero-title">Order & Pay with Ease</h1>
          {/*<p className="hero-subtitle">*/}
          {/*  Transform your dining experience with our innovative restaurant ordering app*/}
          {/*</p>*/}
          <div className="hero-buttons">
            <StoreButtons />
            <a href="#how-it-works" className="btn btn-secondary btn-large">
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* TODO: Uncomment when real partners are available
      <section className="partners-section">
        <div className="container">
          <div className="partners-heading">
            <h2 className="partners-label">Our Partners</h2>
            <p className="partners-sublabel">Restaurants powered by OW App</p>
          </div>
          <div className="partners-track">
            {[
              { name: 'Inside Restaurant', city: 'Paphos, CY' },
            ].map((p) => (
              <div key={p.name} className="partner-card">
                <div className="partner-avatar">{p.name.charAt(0)}</div>
                <div className="partner-info">
                  <span className="partner-name">{p.name}</span>
                  <span className="partner-city">{p.city}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <h2 className="section-title">Welcome to the Future of Dining</h2>
          <p className="section-description">
            Our app revolutionizes the restaurant experience by putting the power of ordering
            and payment directly in your hands. No more waiting for service - browse menus,
            place orders, and pay when you're ready, all from your smartphone.
          </p>
          <div className="about-features">
            <div className="about-feature">
              <div className="about-feature-icon">🍽️</div>
              <h3>Easy Ordering</h3>
              <p>Browse menus and order at your own pace</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">💳</div>
              <h3>Secure Payments</h3>
              <p>Pay safely through the app when you're ready</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">🌍</div>
              <h3>Multi-Language</h3>
              <p>Available in multiple languages for your convenience</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">⚡</div>
              <h3>Fast & Efficient</h3>
              <p>Reduce wait times and enjoy your meal faster</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="video-guide-container">
            <p className="video-guide-label">Video Guide</p>
            <video controls className="video-guide">
              <source src={`${process.env.PUBLIC_URL}/video/ow-client-final-eng.mp4`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <p className="section-subtitle">Simple steps to enhance your dining experience</p>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={feature.id} className="feature-card">
                <div className="feature-number">{index + 1}</div>
                <div className="feature-image-wrapper">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="feature-image"
                  />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section
        className="cta-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/horizontal_background.png)`
        }}
      >
        <div className="container">
          <div className="cta-text-container">
            <h2 className="cta-title">Ready to Transform Your Dining Experience?</h2>
            <p className="cta-description">
              Download our app today and enjoy a seamless ordering and payment experience
            </p>
            <StoreButtons />
          </div>
        </div>
      </section>

      {/* Contact Teaser Section */}
      <section className="contact-teaser-section">
        <div className="container">
          <h2 className="section-title">Have Questions?</h2>
          <p className="section-description">
            We're here to help! Reach out to us with any questions or feedback.
          </p>
          <Link to="/contact" className="btn btn-outline">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;

